/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-10 15:15:33
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 13:44:39
 */
export default [

    {
        path: "EvaluationPlanList",
        name: "EVALUATION_PLAN_LIST",
        meta: {
            title: "测评计划",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/EvaluationPlan/EvaluationPlanList.vue"),
    },
    {
        path: "EvaluationConfig",
        name: "EVALUATION_CONFIG",
        meta: {
            title: "样式配置",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/EvaluationPlan/configureView.vue"),
    },
    {
        path: "CreativeStyle",
        name: "CREATIVE_STYLE",
        meta: {
            title: "创意样式",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/EvaluationPlan/CreativeStyle.vue"),
    },
    {
        path: "DeliveryGroup",
        name: "DELIVERY_GROUP",
        meta: {
            title: "投放组",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/ReleaseAuthority/DeliveryGroup.vue"),
    },

    {
        path: "LaunchSpecialist",
        name: "LAUNCH_SPECIALIST",
        meta: {
            title: "投放专员",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/ReleaseAuthority/LaunchSpecialist.vue"),
    },

    {
        path: "LaunchIdeas",
        name: "LAUNCH_IDEAS",
        meta: {
            title: "创意管理",
            icon: "",
            isNav: true,
        },
        component: () =>
            import("@/views/Launch/Ideas/LaunchIdeas.vue"),
    },
];
// launch:ideas:query
// launch:ideas:add
// launch:ideas:edit
// launch:ideas:delete
